export default __webpack_public_path__ + "static/media/freecharge.5f20fd42.svg";